import { from } from "rxjs";
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
  ChangeDetectorRef 
} from "@angular/core";

import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

declare let $: any;

import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";

import { environment } from "./../../../environments/environment";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { UploadService } from "../../_services/upload.service";
import { AppConfig } from "./../../../app/app.config";
import { UserService } from "../../_services/user.service";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { ClassGetter } from "@angular/compiler/src/output/output_ast";
import { AiSummaryCommonHelper } from "src/app/_helpers/aiSummary.common.helper";
@Component({
  selector: "app-upload-document",
  templateUrl: "./upload-document.component.html",
  styleUrls: ["./upload-document.component.scss"],
  providers: [AppConfig, CommonHelper],
})
export class UploadDocument implements OnInit {  
  @ViewChild("fileUploaded1", { static: false }) fileUploaded1: ElementRef;

  fileToUpload1: File = null;
  docType1 = "";
  fileSize1 = 0;
  associatedFileToUpload: File = null;
  associatedFileName = ""
  associatedFileSize = 0;
  fileName1 = "";
  loggedInUserId: string;
  demographicId: string;
  userId: string;
  companySlug = ConstantHelper.COMPANY_SLUG;
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  childRoute: string;
  patientName: any;
  loggedInUserRoleId:any;
  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };

  delegateId: any;
  isDelegating: any = 0;
  message = Message;
  selectedOption: boolean = false;
  associatedFileDetails : any = {};
  showLoader = false;
  summaryAnswer: any;
  documentIdToGenerateAiSummary: any;
  documentUrlToGenerateAiSummary: any;
  practices: any;
  uploadedPracticsSettings: any;
  showNameAndFolderName1 = false;
  physicans1: any;
  disabled1 = false;
  physicianLength1 = false;
  isDisableSubmitBtn = true;
  physicianInfo1: any = '';
  tempPractice01: any = [];
  practiceInfo1: any = '';
  finalPhysician01: any = [];
  tempPhysician01: any = [];
  show01 = false;
  fileInput: ElementRef<HTMLInputElement>;
  selectedPhysiciansIds: any = [];
  addFileDescription: any;
  addFileContent:any;
  isVideoFile: boolean;
  summaryPopup : any = false;
  selectedAiSummary: any = {};
  isDisabled: boolean = false;
  // cdr: any;
  showModificationFields: boolean;  
  isRegenerate: boolean = false;
  isPreview: boolean = false;
  copyTooltip: string = "Copy Summary";
  copyText: string = "Copy";
  blobUrl: any;
  isSatisfied: false;
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private uploadService: UploadService,
    private userService: UserService,
    public sweetAlertHelper: SweetAlertHelper,
    private renderer: Renderer2,
    private location: Location,
    private aiSummaryCommonHelper: AiSummaryCommonHelper,
    private cdr: ChangeDetectorRef
  ) {
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.demographicId =
      this.activatedRoute.snapshot.paramMap.get("demographicId");
    this.userId = this.activatedRoute.snapshot.paramMap.get("userId");
    this.findUserDetails(this.userId);
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
    this.delegateId = localStorage.getItem("delegateId")
      ? localStorage.getItem("delegateId")
      : this.loggedInUserId;
    this.isDelegating = localStorage.getItem("isDelegating")
      ? localStorage.getItem("isDelegating")
      : 0;
      this.loggedInUserRoleId = localStorage.getItem("loggedInUserRoleId");
  }

  ngOnInit() {
    this.getUserPractices(this.userId)
  }
  
  findUserDetails(demographicUserId) {
    const finalData = {
      id: demographicUserId,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.name_findUserDetailsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.patientName = this.userService.getUS_FromatName(
            apiResponse.commandResult.data.userInfo.FullName
          );
        },
        (err) => {}
      );
  }

  onFileSelected1(event) {
    this.fileToUpload1 = event.target.files.item(0) as File;
    this.fileSize1 = Math.round(this.fileToUpload1.size / 1024);
    this.fileName1 = this.fileToUpload1.name;
    const parts = this.fileName1.split('.');
    const lastPart = parts.length > 0 ? parts[parts.length - 1] : '';
    const fileExtension = lastPart ? lastPart.toLowerCase() : '';
    this.isVideoFile = fileExtension === 'mp4';
  }

  onSelectAssociatedFile(event) {
    this.associatedFileToUpload = event.target.files.item(0) as File;
    this.associatedFileSize = Math.round(this.associatedFileToUpload.size / 1024);
    this.associatedFileName = this.associatedFileToUpload.name;
  }  

  async handleRegenerateClick(): Promise<void> {
    this.isRegenerate = true;
    this.isPreview = false;
    if(!this.addFileDescription && !this.addFileContent || this.docType1 == "")
      {
        this.sweetAlertHelper.alertPopUp("Please Select the Folder and Provide the video description and the content you are looking for")
      }
      else{   
        await this.regenerateAiSummary();
      }
  }

  handlePreviewClick(): void {
    this.isPreview = true;
    this.isRegenerate = false;
    if (this.isVideoFile) {
      if(!this.addFileDescription && !this.addFileContent || this.docType1 == "")
      {
        this.sweetAlertHelper.alertPopUp("Please Select the Folder and Provide the video description and the content you are looking for")
      }
      else
      {
      this.openSummaryPopup();
      }
    } else {
      this.uploadFile();
    }
  }

  async openSummaryPopup(){    
    this.summaryPopup = true;
    await this.uploadVideoFile();
  }
  
  closeSummaryPopup(){    
    this.summaryPopup = false;  
  }

  async onSatisfactionResponse(isSatisfied: boolean, finalData: any): Promise<void> {
    if (isSatisfied) {      
      let data = await this.saveRecordToPatient();       
      finalData.documentId = data;     
      await this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.generateAiSummaryByClick, finalData, this.httpOptions).toPromise();
      const alertStatus = this.sweetAlertHelper.alertPopUp("Summary is uploaded Successfully!");
      if(alertStatus){
      this.isDisabled = false;
      window.location.reload();
      this.closeSummaryPopup();
    }
    } else {
      // this.addFileDescription = "";
      // this.addFileContent = "";  
      this.showModificationFields = true;    
  }
}
async Clearfields(){
      this.addFileDescription = "";
      this.addFileContent = "";  
}

  async uploadFile() {
    if (!this.selectedPhysiciansIds.includes(this.loggedInUserId)) {
      this.selectedPhysiciansIds.push(this.loggedInUserId);
    }   
    let confMsg = "";
    if (
      this.fileUploaded1.nativeElement.value == "" 
    ) {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d1_4
      );
      return;
    }

    if (this.fileToUpload1 && !this.validateFile(this.fileToUpload1.name) || this.associatedFileToUpload && !this.validateFile(this.associatedFileToUpload.name)) {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d21_7
      );
      return false;
    } 
    // else if (this.fileSize1 > 61440 || this.associatedFileSize > 61440) {
    //   const alertStatus = await this.sweetAlertHelper.alertPopUp(
    //     this.message.alertMessages.adminsecondoptwfCOmp.d2d04_1
    //   );
    // } 
    else if (this.fileToUpload1 && this.docType1 == "") {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminUploadComp.uploadFile3
      );
      return false;
    } else {
      let actingUserId = this.delegateId
        ? this.delegateId
        : this.loggedInUserId;
      const alertStatus = await this.sweetAlertHelper.confirmPopUp(
        this.message.confirmTitle,
        this.message.confirmMessages.adminUploaddocComp.uploadFile
      );   
      
      this.showLoader = true;
      if (alertStatus) {
        this.uploadService
          .uploadOtherDocument(
            actingUserId,
            this.userId,
            this.demographicId,
            this.companySlug,
            localStorage.getItem("loggedInUserComapnyId"),
            this.fileToUpload1,
            this.docType1,
            this.fileName1, 
            this.associatedFileName ? this.associatedFileName : '', 
            this.associatedFileToUpload ? this.associatedFileToUpload : '', 
            this.associatedFileDetails.aiSummary ? this.associatedFileDetails.aiSummary : '',
            this.associatedFileDetails.facilityName ? this.associatedFileDetails.facilityName : '', 
            this.associatedFileDetails.facilityAddress ? this.associatedFileDetails.facilityAddress : '', 
            this.associatedFileDetails.facilityContact ? this.associatedFileDetails.facilityContact : '', 
            this.associatedFileDetails.facilityDoctorName ? this.associatedFileDetails.facilityDoctorName : '', 
            this.associatedFileDetails.orderedDoctorName ? this.associatedFileDetails.orderedDoctorName : '', 
            this.associatedFileDetails.testingDoneDate ? this.associatedFileDetails.testingDoneDate : '', 
            this.associatedFileDetails.associatedFileDescription ? this.associatedFileDetails.associatedFileDescription : '',
            this.selectedPhysiciansIds,
            this.addFileDescription ? this.addFileDescription : '',
            this.addFileContent ? this.addFileContent : ''            
          )
          .subscribe(
            async (data: any) => {
              this.showLoader = false;
              this.documentIdToGenerateAiSummary = data.commandResult.data.docId;
              this.documentUrlToGenerateAiSummary = data.commandResult.data.docUrl;
              if (data !== undefined) {              
                if (data.commandResult.success == 1) {
                  const alertStatus =
                    await this.sweetAlertHelper.confirmPopUpwithYesOrNo(
                      this.message.confirmTitle,
                      this.message.confirmMessages.adminUploaddocComp
                        .uploadFile1
                    );
                  if (alertStatus) {
                    const aiSummary = await this.aiSummaryCommonHelper.generateAiSummaryOnDocumentUpload(this.documentUrlToGenerateAiSummary,this.addFileDescription,this.addFileDescription,this.documentIdToGenerateAiSummary)
                    this.selectedAiSummary = aiSummary;                    
                    window.location.reload();
                  } else {
                    this.router.navigate([
                      "/" +
                        this.childRoute +
                        "/demographics/" +
                        this.loggedInUserId,
                    ]);
                    // this.location.back();
                    const aiSummary = await this.aiSummaryCommonHelper.generateAiSummaryOnDocumentUpload(this.documentUrlToGenerateAiSummary,this.addFileDescription,this.addFileDescription,this.documentIdToGenerateAiSummary)
                    this.selectedAiSummary = aiSummary;                   
                    window.location.reload();
                  }
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.router.navigate([
          "/" + this.childRoute + "/demographics/" + this.loggedInUserId,
        ]);
      }
    }
  }

  async uploadVideoFile() {
    if (!this.selectedPhysiciansIds.includes(this.loggedInUserId)) {
      this.selectedPhysiciansIds.push(this.loggedInUserId);
    }    
    let confMsg = "";
    if (
      this.fileUploaded1.nativeElement.value == "" 
    ) {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d1_4
      );
      return;
    }

    if (this.fileToUpload1 && !this.validateFile(this.fileToUpload1.name) || this.associatedFileToUpload && !this.validateFile(this.associatedFileToUpload.name)) {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d21_7
      );
      return false;
    } 
    // else if (this.fileSize1 > 61440 || this.associatedFileSize > 61440) {
    //   const alertStatus = await this.sweetAlertHelper.alertPopUp(
    //     this.message.alertMessages.adminsecondoptwfCOmp.d2d04_1
    //   );
    // } 
    else if (this.fileToUpload1 && this.docType1 == "") {
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminUploadComp.uploadFile3
      );
      return false;
    } else {
      let actingUserId = this.delegateId
        ? this.delegateId
        : this.loggedInUserId;
            
      this.showLoader = true;
      
        this.uploadService
          .uploadDocument(
            actingUserId,
            this.userId,
            this.demographicId,
            this.companySlug,
            localStorage.getItem("loggedInUserComapnyId"),
            this.fileToUpload1,
            this.docType1,
            this.fileName1, 
            this.associatedFileName ? this.associatedFileName : '', 
            this.associatedFileToUpload ? this.associatedFileToUpload : '', 
            this.associatedFileDetails.aiSummary ? this.associatedFileDetails.aiSummary : '',
            this.associatedFileDetails.facilityName ? this.associatedFileDetails.facilityName : '', 
            this.associatedFileDetails.facilityAddress ? this.associatedFileDetails.facilityAddress : '', 
            this.associatedFileDetails.facilityContact ? this.associatedFileDetails.facilityContact : '', 
            this.associatedFileDetails.facilityDoctorName ? this.associatedFileDetails.facilityDoctorName : '', 
            this.associatedFileDetails.orderedDoctorName ? this.associatedFileDetails.orderedDoctorName : '', 
            this.associatedFileDetails.testingDoneDate ? this.associatedFileDetails.testingDoneDate : '', 
            this.associatedFileDetails.associatedFileDescription ? this.associatedFileDetails.associatedFileDescription : '',
            this.selectedPhysiciansIds,
            this.addFileDescription ? this.addFileDescription : '',
            this.addFileContent ? this.addFileContent : '',       
            
          )
          .subscribe(
            async (data: any) => {
              this.showLoader = true;
              this.documentUrlToGenerateAiSummary = data.commandResult.data;
              if (data != undefined) {                  
                  try {
                      const aiSummary = await this.aiSummaryCommonHelper.generateAiSummaryOnVideoUpload(this.documentUrlToGenerateAiSummary, this.addFileDescription, this.addFileContent);
                      this.selectedAiSummary = aiSummary;                      
                  } catch (error) {
                      console.error("Error in calling generateAiSummaryOnVideoUpload:", error);
                  }                  
                  this.cdr.detectChanges();
              }
              this.showLoader = false;
          },
            (error) => {
              console.log(error);
            }
          );
      this.isPreview =false;
      this.isRegenerate = false;
    }
  }

  async saveRecordToPatient() {
    let actingUserId = this.delegateId ? this.delegateId : this.loggedInUserId;
    this.showLoader = true;
  
    try {
      const data: any = await this.uploadService
        .FinaluploadDocument(
          actingUserId,
          this.userId,
          this.demographicId,
          this.companySlug,
          localStorage.getItem("loggedInUserComapnyId"),
          this.fileToUpload1,
          this.docType1,
          this.fileName1,
          this.associatedFileName ? this.associatedFileName : "",
          this.associatedFileToUpload ? this.associatedFileToUpload : "",
          this.associatedFileDetails && this.associatedFileDetails.aiSummary ? this.associatedFileDetails.aiSummary : "",
          this.associatedFileDetails && this.associatedFileDetails.facilityName ? this.associatedFileDetails.facilityName : "",
          this.associatedFileDetails && this.associatedFileDetails.facilityAddress ? this.associatedFileDetails.facilityAddress : "",
          this.associatedFileDetails && this.associatedFileDetails.facilityContact ? this.associatedFileDetails.facilityContact : "",
          this.associatedFileDetails && this.associatedFileDetails.facilityDoctorName ? this.associatedFileDetails.facilityDoctorName : "",
          this.associatedFileDetails && this.associatedFileDetails.orderedDoctorName ? this.associatedFileDetails.orderedDoctorName : "",
          this.associatedFileDetails && this.associatedFileDetails.testingDoneDate ? this.associatedFileDetails.testingDoneDate : "",
          this.associatedFileDetails && this.associatedFileDetails.associatedFileDescription ? this.associatedFileDetails.associatedFileDescription : "",
          this.selectedPhysiciansIds,
          this.addFileDescription ? this.addFileDescription : "",
          this.addFileContent ? this.addFileContent : "",
          this.documentUrlToGenerateAiSummary ? this.documentUrlToGenerateAiSummary : ""
        )
        .toPromise();
  
      this.showLoader = false;
      this.documentIdToGenerateAiSummary = data.commandResult.data.docId;
      this.documentUrlToGenerateAiSummary = data.commandResult.data;      
      return this.documentIdToGenerateAiSummary;
  
    } catch (error) {
      this.showLoader = false;
      console.error("Error in saveRecordToPatient:", error);
      throw error;
    } finally {
      this.isPreview = false;
      this.isRegenerate = false;
    }
  }
  

  async regenerateAiSummary() {
    this.showLoader = true;
    const aiSummary = await this.aiSummaryCommonHelper.generateAiSummaryOnVideoUpload(this.documentUrlToGenerateAiSummary,this.addFileDescription,this.addFileContent);
    this.selectedAiSummary = aiSummary;    
    this.showModificationFields = false;
    this.showLoader = false;
    this.cdr.detectChanges();
    return;
}


// Copy the summary to clipboard without HTMl tags
copyAiSummary(text: string) {
  if (text) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = text; // Assign the HTML content
    const plainText = tempElement.textContent || tempElement.innerText || "";
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = plainText; 
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    this.copyTooltip = "Copied Summary";
    this.copyText = "Copied";
    setTimeout(() => {
      this.copyTooltip = "Copy Summary";
      this.copyText = "Copy";
    }, 2000);
  
  }
}


  async gotToDashboard() {
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminChangePassComp.onReset
    );
    if (alertStatus) {
      this.router.navigate([
        "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
      ]);
    }
  }

  validateFile(name: String) {
    let ext = name.substring(name.lastIndexOf(".") + 1);
    if (
      ext.toLowerCase() == "png" ||
      ext.toLowerCase() == "jpg" ||
      ext.toLowerCase() == "jpeg" ||
      ext.toLowerCase() == "pdf" ||
      ext.toLowerCase() == "mp4"
    ) {
      return true;
    } else {
      return false;
    }
  }


  async onReset() {
      this.router.navigate([
        "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
      ]);
    // }
  }

  async goToDemographics() {
    this.location.back();
  }

  isFileInputDisabled(): boolean {
    return this.selectedOption == false;
}


getUserPractices(patientId) {
  const finalData = {
    loggedInUserId: this.userId,
  };
  this.showLoader = true;
  this.http
    .post(
      this.appConfig.getPhpUrl() + ApiHelper.php_findUserPracticeApi,
      finalData,
      this.httpOptions
    )
    .subscribe(
      (apiResponse: any) => {
        this.practices = apiResponse.commandResult.data.companiesList;
        this.uploadedPracticsSettings = {
          singleSelection: false,
          idField: 'company_url',
          textField: 'company',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 3,
          allowSearchFilter: true,
        };
        this.showLoader = false;
      },
      (err) => {
        console.error(err);
      }
    );
}

onChangePractice(companyUrl) {
  const reqData = {
    company_slug: companyUrl,
    loggedInUserId: this.userId,
  };

  this.http
    .post(
      this.appConfig.getPhpUrl() + ApiHelper.php_findUserDoctorsByPracticeApi,
      reqData,
      this.httpOptions
    )
    .subscribe(
      (apiResponse: any) => {
            if(companyUrl == 0){
              this.showNameAndFolderName1 = true;
            }
          this.physicans1 = apiResponse.commandResult.data.companiesList;
          this.disabled1 = false;
          if (Array.isArray(this.physicans1) && this.physicans1.length > 0) {
            this.physicianLength1 = true;
          } else {
            this.physicianLength1 = false;
          }
        // }
        this.isDisableSubmitBtn = false;
      },
      (err) => {
      }
    );
}

async listData(file) {
  if (this.physicianInfo1.length <= 0) {
    await this.sweetAlertHelper.alertPopUp('Please select practice or physician');
    return false;
  }
    if (this.physicianInfo1 == 'all') {
      this.tempPractice01.push(
        this.practices.find((x) => x.company_url == this.practiceInfo1)
      );
    } else {
      this.physicianInfo1.forEach((element) => {
        const existingPhysician = this.finalPhysician01.find((x) => x.physician_id == element);
        if (!existingPhysician) {
          const selectedPhysician = this.physicans1.find((x) => x.physician_id == element);
          if (selectedPhysician) {
            this.finalPhysician01.push(selectedPhysician);
            this.tempPhysician01.push(selectedPhysician);
            this.selectedPhysiciansIds.push(selectedPhysician.physician_id);
          }
        }
      });
    this.show01 = true;
  }
}



onChangePhysician(value, j) {
  if (value == 'all' && j == 0) {
    // this.disabled1 = true;
  }
  if (value == 'all' && j == 1) {
    // this.disabled2 = true;
  }
  if (value == 'all' && j == 2) {
    // this.disabled3 = true;
  }
  if (value == 'all' && j == 3) {
    // this.disabled4 = true;
  }
  if (value == 'all' && j == 4) {
    // this.disabled5 = true;
  }
}

getMaxDate(): string {
  const currentDate = new Date();
  return currentDate.toISOString().split('T')[0];
}

}
